<template>
    <div>
        <footer>
            <div class="pc-footer">
                <div class="clearfix footer">
                    <div class="menu">
                        <dl>
                            <dd>关于我们</dd>
                            <dt @click.stop="goDetail('/about/group')">公司简介</dt>
                            <dt @click.stop="goDetail('/about/culture')">企业文化</dt>
                            <dt @click.stop="goDetail('/about/develop')">发展历程</dt>
                            <dt @click.stop="goDetail('/about/organization')">组织结构</dt>
                            <dt @click.stop="goDetail('/about/honor')">资质荣誉</dt>
                            <dt @click.stop="goDetail('/about/duty')">社会责任</dt>
                        </dl>
                        <dl>
                            <dd>梨酒系列</dd>
                             <dt
                                 v-for="(item,index) in goodsTitList"
                                 :key="index"
                                 @click.stop="jumpGoods(item,index)"
                             >{{ item.CategoryName }}</dt>
                        </dl>
                        <dl>
                            <dd>新闻动态</dd>
                            <dt @click.stop="goDetail('/news/information')">新闻动态</dt>
                            <dt @click.stop="goDetail('/news/magazine')">品牌杂志</dt>
                            <dt @click.stop="goDetail('/news/notice')">公告通知</dt>
                            <dt @click.stop="goDetail('/news/video')">视频库</dt>
                            <dt @click.stop="goDetail('/news/group')">集团资讯</dt>
                            <dt @click.stop="goDetail('/news/industry')">行业资讯</dt>
                        </dl>
                        <dl>
                            <dd>服务商</dd>
                            <dt @click.stop="goDetail('/support/shop')">专卖店查询</dt>
                            <dt @click.stop="goDetail('/support/security')">防伪追溯</dt>
                            <dt @click.stop="goDetail('/support/contact')">联系我们</dt>
                        </dl>
                    </div>

                    <div class="info">
                        <div class="phone">
                            <img src="@/assets/img/tel.png" alt="">
                            <div class="phone-num">0310-8067822</div>
                        </div>

                        <div class="address">
                            <img src="@/assets/img/address.png" alt="">
                            <div class="address-text">邯郸市临漳县五粮液大道9号</div>
                        </div>

                    </div>

                    <div class="qr-code">
                        <div class="qr-item">
                            <img src="@/assets/img/wechat_subscription.jpg" alt="">
                            <p class="qr-text">永不分梨微信服务号</p>
                        </div>

                        <div class="qr-item">
                            <img src="@/assets/img/wechat_service.jpg" alt="">
                            <p class="qr-text">永不分梨微信订阅号</p>
                        </div>

                    </div>

                </div>

                <div class="bottom">
                    © 2013-{{year}}  邯郸永不分梨酒业股份有限公司　　
                    <a href="https://beian.miit.gov.cn/" target="_blank">{{ office.ICPRecordNo }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a  href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{office.PublicSecurityRecordNo}}</a>
                </div>
            </div>

            <div class="md-footer">
                <div class="md-phone">
                    <img src="@/assets/img/tel.png" alt="">
                    <div class="md-phone-num">0310-8067822</div>
                </div>

                <div class="md-phone">
                    <img src="@/assets/img/address.png" alt="">
                    <div class="md-phone-address">邯郸市临漳县五粮液大道9号</div>
                </div>



                <div class="md-qr-code">
                    <div class="md-qr-item">
                        <img src="@/assets/img/wechat_service.jpg" alt="">
                        <p class="md-qr-text">永不分梨微信订阅号</p>
                    </div>

                    <div class="md-qr-item">
                        <img src="@/assets/img/wechat_subscription.jpg" alt="">
                        <p class="md-qr-text">永不分梨微信服务号</p>
                    </div>

                </div>

                <div class="md-copy">
                    © 2013-{{year}} 邯郸永不分梨酒业股份有限公司
                    <br>
                    <p class="md-btm-num">
                        <a href="https://beian.miit.gov.cn/" target="_blank">{{ office.ICPRecordNo }}</a>
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{office.PublicSecurityRecordNo}}</a>
                    </p>
                </div>

            </div>

        </footer>
    </div>
</template>

<script>
import {websiteApi} from "@/api/api";

export default {
    data(){
        return{
            goodsTitList: [],
            office: {},
            year: ''
        }
    },
    created() {
        this.year = new Date().getFullYear()
        this.getGoodCogyList()
        this.getOffice()
    },
    methods: {
        jumpPage(url) {
            this.$router.push(url)
            document.documentElement.scrollTop = 0
        },
        async getGoodCogyList() {
            const res = await websiteApi.getGoods({
                Action: "guanying.showcategory.list.get",
                DeviceType: this.$deviceType,
            })
            if (res.Status === "Success") {
                this.goodsTitList = res.Data;
            }
        },
        jumpGoods(item, index) {
            const url = window.location.protocol+"//"+window.location.host
            window.open(url +'/product?ShowCategoryID='  + item.ShowCategoryID + '&i=' + index )

        },
        jumpHref(url){
            window.location.href = url
        },
        async getOffice(){
            const res = await websiteApi.getConfig({
                Action: 'guanying.keeprecord.get',
                DeviceType: this.$deviceType,
            })
            this.office = res.Data
            document.querySelectorAll("link[rel*='icon']").forEach(item => {
                item.href = this.$AttachmentDomainName +res.Data.Icon;
            })
        },
        goDetail(page){
            const url = window.location.protocol+"//"+window.location.host
            window.open(url + page)
        }
    }
}
</script>

<style lang="scss" scoped>
footer{
    width: 100%;
    background: #303338;
    .footer{
        padding-bottom: 30px;
        border-bottom: 1px solid rgb(238 238 238 / 20%)
    }

    .menu{
        float: left;
        dl{
            width: 210px;
            float: left;
            dd {
                font-size: 24px;
                font-family: SimHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 60px;
            }
            dt{
                font-size: 16px;
                font-family: SimHei;
                font-weight: 400;
                color: #989AA5;
                margin: 20px 0;
                cursor: pointer;
            }
        }
    }

    .info{
        float: left;
        margin-top: 60px;
        .phone{
            display: flex;
            align-items: center;
            >img {
                width: 29px;
                height: 30px;
            }
            .phone-num{
                font-size: 30px;
                font-family: SimHei;
                font-weight: 400;
                color: #989AA5;
                line-height: 65px;
                margin-left: 20px;
            }
        }

        .address{
            display: flex;
            align-items: center;
            >img {
                width: 31px;
                height: 28px;
            }
            .address-text{
                font-size: 16px;
                font-family: SimHei;
                font-weight: 400;
                color: #989AA5;
                line-height: 24px;
                margin-left: 20px;
            }
        }

    }

    .qr-code{
        float: right;
        margin-top: 60px;
        .qr-item{
            float: right;
            height: auto;
            text-align: center;
            margin-left: 40px;
            >img{
                width: 150px;
                height: 150px;
            }
            .qr-text{
                text-align: center;
                font-size: 16px;
                font-family: SimHei;
                font-weight: 400;
                color: #888888;
                line-height: 36px;
            }
        }
    }


    .bottom{
        height: 60px;
        line-height: 60px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #989AA5;
        a{
            line-height: 60px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #989AA5;
        }
    }


    .md-footer{
        .md-phone{
            display: flex;
            align-items: center;
            margin-bottom: 30px;
            .md-phone-num{
                font-size: 24px;
                color: #989AA5;
                line-height: 1.5;
                margin-left: 20px;
            }
            .md-phone-address{
                font-size: 18px;
                color: #989AA5;
                line-height: 1.5;
                margin-left: 20px;
            }
            >img{
                width: 27px;
                height: 25px;
            }
        }
    }


    .md-qr-code{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 30px auto;
        .md-qr-item{
            text-align: center;
            >img{
                width: 120px;
                height: auto;
            }
            .md-qr-text{
                font-size: 12px;
                color: #8F929C;
                line-height: 18px;
                margin-top: 10px;
            }
        }
    }

    .md-copy{
        padding: 10px 0 20px 0;
        font-size: 12px;
        color: #989AA5;
        line-height: 20px;
        border-top: 1px solid rgb(221 221 221 / 25%);
        .md-btm-num{
            display: flex;
            justify-content: space-between;
            a {
                font-size: 12px;
                font-weight: 400;
                color: #989AA5;
            }
        }
    }

    @media screen and (max-width: 960px){
        .pc-footer{
            display: none;
        }
        .md-footer{
            display: block;
            padding: 50px 50px 0px;
        }
    }

    @media screen and (min-width: 960px){
        .pc-footer{
            display: block;
            padding: 90px 160px 0;
        }
        .md-footer{
            display: none;
        }
    }
}
</style>
